export enum FileTypeEnum {
  PNG = 'png',
  JPEG = 'jpeg',
  JPG = 'jpg',
  PDF = 'pdf',
  // MP3 = 'mp3',
  // DOCX = 'docx',
  EXCEL = 'xlsx',
  CSV = 'csv',
}
